import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import cx from 'classnames';
import UnitsTable from '../UnitsTable';
import { compose } from '../../../../src/web/utils/react';
import { BUILDER } from '../../../../src/shared/abilities';
import { create as createLead } from '../../../../src/web/store/modules/lead';
import { getCompanyName } from '../../../../src/web/store/modules/company';
import { getActionButtons, getColors } from '../../../../src/web/store/modules/site';
import { getPageLocale } from '../../../../src/web/store/modules/page';
import { getUserIpAddress } from '../../../../src/web/store/modules/user';
import globalClasses from '../../../../src/web/theme/facility-globals.scss';
import { DEFAULT_PRICE_DISPLAY } from '../../../widgets/dynamic/FacilityUnitsOne/constants';

const propTypes = {
  facility: PropTypes.shape({
    settings: PropTypes.shape({
      enablePublicDescription: PropTypes.string,
    }),
  }),
  // eslint-disable-next-line react/forbid-prop-types
  colors: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  columnHeadings: PropTypes.object,
  tableTheme: PropTypes.string.isRequired,
  priceDisplay: PropTypes.object,
};

const defaultProps = {
  facility: { settings: {} },
  colors: undefined,
  columnHeadings: undefined,
  priceDisplay: DEFAULT_PRICE_DISPLAY,
};

const FacilityUnits = ({
  facility,
  colors,
  columnHeadings,
  unitSummary,
  unitGroups,
  tableTheme,
  priceDisplay,
  ...rest
}) => {
  const getColumnHeadings = () => {
    const { settings } = facility;

    const defaults = {
      size: 'Size',
      unitDetails: 'Unit Details',
      price: 'Price',
    };

    if (settings.enablePublicDescription) {
      defaults.specials = 'Promotions';
    }

    const headings = Object.assign(defaults, columnHeadings);

    return headings;
  };

  if (!facility) {
    // todo: Maybe show some loading stuff
    return false;
  }

  const className = cx(
    globalClasses.section,
    globalClasses.sectionNoPadBtm,
    globalClasses.sectionNoPadTopMobile,
  );

  return (
    <div id="unitstable" data-testid="unitstable">
      <div className={className}>
        <UnitsTable
          {...rest}
          facility={facility}
          theme={tableTheme}
          colors={colors}
          columnHeadings={getColumnHeadings()}
          priceDisplay={priceDisplay}
        />
      </div>
    </div>
  );
};

FacilityUnits.propTypes = propTypes;
FacilityUnits.defaultProps = defaultProps;

FacilityUnits.fragments = {
  facility: gql`
    fragment FacilityUnitsFacility on Facility {
      ...UnitsTableFacility
    }

    ${UnitsTable.fragments.facility}
  `,
};

const component = compose(
  connect(
    (state, props) => ({
      routing: state.routing,
      actionButtons: getActionButtons(state),
      colors: getColors(state),
      locale: getPageLocale(state) || props.locale, // frontend || backend
      companyName: getCompanyName(state),
      ipAddress: getUserIpAddress(state),
    }),
    { createLead },
  ),
)(FacilityUnits);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
